import { useCallback } from 'react';

type Params = { isStartover: boolean; onJumpToLive(): Promise<void> };

function useVideoEnd({ isStartover, onJumpToLive }: Params) {
    return useCallback(() => {
        if (isStartover) {
            onJumpToLive();
        }
    }, [isStartover, onJumpToLive]);
}

export default useVideoEnd;
